export default {
  CLIENT: {
    Title: 'Client',
  },
  GENERAL: {
    Title: 'General',
  },
};
